import { css, SerializedStyles } from '@emotion/react';

export const useStyles = () => ({
  whiteContentTopRadius: css({
    backgroundColor: "#ffffff",
    marginTop: "-10px !important",
    textAlign: "center",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
    paddingBottom: "20px",
    overflow: "hidden",
  }),
  greyContent: css({
    backgroundColor: "#f3f6f6",
    overflow: "auto",
    padding: "15px",
    paddingBottom: "7px",
  }),
});
